export default "__VITE_ASSET__Bi$S2ryr__"